/**
 * @generated SignedSource<<b5a23e1fa21b292f2028014c81ae2904>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDeposit_item$data = {
  readonly isDepositAvailable: boolean;
  readonly serviceId: string | null;
  readonly " $fragmentType": "PdpSharedDeposit_item";
};
export type PdpSharedDeposit_item$key = {
  readonly " $data"?: PdpSharedDeposit_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDeposit_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDeposit_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        }
      ],
      "kind": "ScalarField",
      "name": "isDepositAvailable",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "51959073e97db7635d60956c8fb243f6";

export default node;
